<template>

    <div class="pager row" v-if="(meta != null)">
        <span class="pagerdetails medium-12 large-4 columns">&nbsp;
            <div v-if="(meta.total == 0)" class="leftalign">
                No matching products or brands found
            </div>
        </span>

        <div class="pagercontrols medium-4 large-4 columns">
            <span v-if="(meta.current_page != 1)" class="paginationbox active"><a v-on:click="previous()"><i
                    class="fa fa-angle-double-left"></i> Previous</a></span>
            <span v-if="(page < meta.last_page)" class="paginationbox active"><a v-on:click="next()">Next <i
                    class="fa fa-angle-double-right"></i> </a></span>
        </div>

        <div class="pagerdetails medium-4 large-4 columns">
            <!--
              "meta": {
                "current_page": 1,
                "from": 1,
                "last_page": 3,
                "path": "https://ws2.nongmoproject.org/api/v1/get_brands_by_category",
                "per_page": 50,
                "to": 50,
                "total": 103
              }
               -->
            <div v-if="(meta.total > 0)">
                (Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} brands)
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'Pager',
        components: {},
        props: {
            page: {
              type: Number,
              required: true
            },
            meta:
                {
                    type: Object,
                    required: true
                },
        },
        data() {
            return {}
        },
        methods: {
            next() {
                this.$emit('next');
            },
            previous() {
                this.$emit('previous');
            }
        }
    }
</script>

